import { ReplaySubject } from 'rxjs';
import { Component, Inject, OnDestroy } from '@angular/core';
import { DataService } from 'app/shared/services/dataService';
import { UploadResult } from 'app/shared/models/uploadResult';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-ocme',
  templateUrl: './ocme.component.html',
  styleUrls: ['./ocme.component.css']
})
export class OcmeComponent implements  OnDestroy   {
  message: string = '';
  uploadResult: UploadResult;
  showProgress: boolean = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    @Inject(MAT_DIALOG_DATA) public isNonFatalUpload: boolean,
    private dialogRef: MatDialogRef<OcmeComponent>,
    private dataService: DataService
  ) { }

  fileChange(event) {
    this.clear();
    if ( event.target.files.length === 0) {
      this.message = 'no file found or file had no data';
    }
    let confirmationString = 'Confirm that you intend to upload files:\n';
    for (let file of event.target.files) {
      confirmationString = confirmationString + file.name + '\n';
    }
    if (confirm(confirmationString) === true) {
      this.showProgress = true;
      this.dataService.uploadFiles(event.target.files, this.isNonFatalUpload).takeUntil(this.destroyed$).subscribe(res => {

        this.showProgress = false;
        this.uploadResult = res;
        this.message = this.uploadResult.Message;
        event.target.value = '';
        }
        , error => {
          this.message = 'An error has occurred with uploading file' + error;
           this.showProgress = false;
           event.target.value = '';
        });
    }
  }

  clear() {
    this.showProgress = false;
    this.message = '';
    this.uploadResult = null;
  }

  onClose() {
    this.clear();
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
